import { BaseFieldWidget, ModelFieldType, ViewType, SPI, FormStringUploadFieldWidget, FormStringUploadImgFieldWidget } from '@kunlun/dependencies';
import CustomUploadImage from './DragSortImageUploader.vue';
@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: [ModelFieldType.String, ModelFieldType.Text],
    name: 'detailUrls',
    model: 'deli.retail.BackendRetailItem',
    widget: ['UploadImg']
  })
)
@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: [ModelFieldType.String, ModelFieldType.Text],
    name: 'picsUrls',
    model: 'deli.retail.BackendRetailItem',
    widget: ['UploadImg']
  })
)
export class DragSortImageUploader extends FormStringUploadImgFieldWidget {
  public initialize(config) {
    super.initialize(config);
    this.setComponent(CustomUploadImage);
    return this;
  }
}
